import { Field } from "@base-ui/react/field";

export type FieldErrorsProps = {
  errorProps?: Field.Error.Props;
  requiredMessage?: string;
  typeMismatchMessage?: string;
};

/**
 * Renders at most one validation error per field.
 *
 * Priority (first match wins, CSS hides the rest):
 *  1. `valueMissing`   — browser required check (custom message).
 *  2. `typeMismatch`   — browser format check, e.g. invalid email (custom message when provided).
 *  3. Catch-all        — any other invalid state: native errors or `customError` from validate.
 */
export function FieldErrors({
  errorProps,
  requiredMessage = "This field is required",
  typeMismatchMessage,
}: FieldErrorsProps) {
  return (
    <span className="*:hidden *:first:block">
      <Field.Error match="valueMissing" className="label-error" {...errorProps}>
        {requiredMessage}
      </Field.Error>
      {typeMismatchMessage && (
        <Field.Error
          match="typeMismatch"
          className="label-error"
          {...errorProps}
        >
          {typeMismatchMessage}
        </Field.Error>
      )}
      <Field.Error className="label-error" {...errorProps} />
    </span>
  );
}
